import * as Actions from "../incidentcallstats.actions";

const initialState = {
  unitcode: "",
  loading: true,
  appliances: [],
  lastpagertime: null,
  lastbrigademessage: "",
  lastpagermessage: "",
  lastagency: "",
  brigadecalls: 0,
  callssince: "",
  isActive: false,
  signalr: false
};

const callstatsReducer = (state = initialState, action) => {
  switch (action.type) {
    case Actions.RECEIVE_MESSAGE: {
      return {
        ...state,
        directMessage: action.payload
      };
    }
    case Actions.EAS_MESSAGE: {
      return {
        ...state,
        lastpagermessage: action.payload.message,
        lastbrigademessage: action.payload.unitname,
        lastagency: action.payload.agency,
        lastpagertime: new Date()
      }
    }
    case Actions.UNIT_UPDATE: {
      return {
        ...state,
        brigadecalls: action.payload.numCalls,
        callssince: action.payload.reportingperiodstart,
        appliances: action.payload.applianceStatuses,
        isActive: action.payload.isActive
      }
    }
    case Actions.UNIT_CODE: {
      localStorage.setItem('unit_code', action.payload);
      var myDynamicManifest = {
        "name": "Firebrigade.cloud App",
        "short_name": "Firebrigade App",
        "display": "standalone",
        "start_url": window.origin + "/" + action.payload,
        "theme_color": "#000000",
        "background_color": "#ffffff",
        "icons": [
          {
            "src": "/favicon.ico",
            "sizes": "64x64 32x32 24x24 16x16",
            "type": "image/x-icon"
          },
          {
            "src": "/logo192.png",
            "type": "image/png",
            "sizes": "192x192"
          },
          {
            "src": "/logo512.png",
            "type": "image/png",
            "sizes": "512x512"
          }
        ]
      }
      const stringManifest = JSON.stringify(myDynamicManifest);
      const blob = new Blob([stringManifest], {type: 'application/json'});
      const manifestURL = URL.createObjectURL(blob);
      document.querySelector('#manifest-placeholder').setAttribute('href', manifestURL);

      return {
        ...state,
        unitcode: action.payload
      }
    }
    case Actions.SET_SIGNALRSTATE: {
      return {
        ...state,
        signalr: action.payload
      }
    }
    default: {
      return state;
    }
  }
};

export default callstatsReducer;
